import React from 'react';
import { Bullseye, Flex } from '@patternfly/react-core';
import { GithubIcon, InstagramIcon, TwitterIcon } from '@patternfly/react-icons';

class SocialMediaContainer extends React.Component<any, any> {
  public render() {
    return (
      <Bullseye className="social-media-container">
        <div className="version">v2.0.0</div>
        <Flex spaceItems={{ default: "spaceItemsXl" }}>
          <a
            href="https://www.github.com/aptmac/draftaid-react"
            target="_blank"
            rel="noreferrer"
            aria-label="github-button"
            className="social github"
          >
            <GithubIcon size="md" />
          </a>
          {/* <a href="" target="_blank" aria-label="instagram-button" className="social instagram"><InstagramIcon size="md"/></a>
          <a href="" target="_blank" aria-label="twitter-button" className="social twitter"><TwitterIcon size="md"/></a> */}
        </Flex>
        <div className="copyright">Ume Studios 2022</div>
      </Bullseye>
    );
  }
}

export { SocialMediaContainer };
